import { Role } from "./commons/models/role";

export interface RoleMap {
	contexts: Role[][];
	templates: Role[][];
	translations: Role[][];
	offlineFlags: Role[][];
	sequences: Role[][];
	timers: Role[][];
	contact: Role[][];
	faq: Role[][];
	csat: Role[][];
	partner: Role[][];
	origin: Role[][];
	seller: Role[][];
	paymentConfig: Role[][];
	emailsTemplates: Role[][];
}

/* Some examples
 Admin OR Client
[[Admin], [Client]]

 Admin AND client:
[[Admin, Client]]

 (Admin AND Client) OR Configuration
[[Admin, Client], [Configuration]]
*/
export const linksRoles: RoleMap = {
	contexts: [[Role.Admin], [Role.Client]],
	templates: [[Role.Admin], [Role.Client]],
	translations: [[Role.Admin], [Role.Client], [Role.ClaimPortalAdmin]],
	offlineFlags: [[Role.Admin], [Role.Client]],
	sequences: [[Role.Admin], [Role.Client]],
	timers: [[Role.Admin], [Role.Client]],
	contact: [[Role.Admin], [Role.Client], [Role.ClaimPortalAdmin]],
	faq: [[Role.Admin], [Role.Client], [Role.ClaimPortalAdmin]],
	csat: [[Role.Admin], [Role.Client], [Role.ClaimPortalAdmin]],
	partner: [[Role.Admin], [Role.Client]],
	origin: [[Role.Admin], [Role.Client]],
	seller: [[Role.Admin], [Role.Client]],
	paymentConfig: [[Role.Admin], [Role.Client]],
	emailsTemplates: [[Role.Admin], [Role.Client]]
}
